m<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Leaves</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Leaves</li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" @click="getEmployeeLeaves">All</a>
                  <a class="dropdown-item" @click="getEmployeeNewLeaves">New</a>
                  <a class="dropdown-item" @click="getEmployeeApprovedLeaves"
                    >Approved</a
                  >
                  <a class="dropdown-item" @click="getEmployeeRejectedLeaves"
                    >Rejected</a
                  >
                </div>
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Add Leave</a
                >
                <a class="btn add-btn mr-1" @click="openDialogExport"
                  ><i class="fa fa-plus"></i> Export Report</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3">
              <div class="stats-info">
                <h6>Today Presents</h6>
                <h4>
                  {{ totalEmployees - totalAbsence }} / {{ totalEmployees }}
                </h4>
              </div>
            </div>
            <div class="col-md-3">
              <div class="stats-info">
                <h6>Pending Requests</h6>
                <h4>{{ totalPendingLeave }}</h4>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-12 col-md-12">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="searchParam"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search</label>
              </div>
            </div>
          </div>
          <!-- Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="filteredEmployeeLeaves"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.fromDate`]="{ item }">
                    {{
                      item.fromDate
                        ? new Date(item.fromDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.toDate`]="{ item }">
                    {{
                      item.toDate
                        ? new Date(item.toDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.allow`]="{ item }">
                    <input
                      disabled
                      v-model="item.needAllowance"
                      readonly
                      type="checkbox"
                    />
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0 && !item.nextApproval"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                        <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'leavehistory',
                          params: { id: item.employee.id }
                        }"> View History</router-link>
                        <a class="dropdown-item" @click="onDownload(item)" v-if="(item.leaveTypeId == 1 || item.leaveTypeId == 2) && item.status == 1"
                          ><i class="fa fa-file-o m-r-5"></i> Download Certificate</a
                        >
                        <a class="dropdown-item" @click="setDeleteLeave(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.employee.id }
                        }"
                        class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.employee.id }
                        }"
                        >{{
                          `${item.employee.firstName} ${item.employee.lastName}`
                        }}</router-link
                      >
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <!-- <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a> -->

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="!item.nextApproval && item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Add Leave Modal -->
          <v-dialog v-model="dialog" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Leave</h5>
                <button type="button" @click="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Employee <span class="text-danger">*</span></label>
                    <multiselectvue
                      class="from-control"
                      v-model="employeeName"
                      placeholder="Select Employee"
                      :custom-label="nameOfEmployee"
                      :options="sortedEmployeeNames"
                      :searchable="true"
                      @select="optionSelected"
                      :allow-empty="false"
                    >
                      <template slot="singleLabel" slot-scope="{ option }"
                        >{{ option.firstName }} {{ option.lastName }}</template
                      >
                    </multiselectvue>
                    <!-- <select class="form-control" v-model="employeeId">
                      <option disabled>Select Staff</option>
                      <option
                        v-for="member in employees"
                        :key="member.id"
                        :value="member.id"
                      >
                        {{ member.lastName + " " + member.firstName }}
                      </option>
                    </select> -->
                  </div>
                  <div class="form-group">
                    <label>Leave Type <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="leaveTypeId"
                      @change="getRemainingLeaveDays"
                    >
                      <option>Select Leave Type</option>
                      <option
                        v-for="item in leaveTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="form-group wrapper-class"
                    v-if="eligibileDays > 0"
                  >
                    <label>From <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="fromDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label>To <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="toDate"
                        bootstrap-styling
                        class="form-control datetimepicker"
                        @closed="getNoOfDaysInterval()"
                        type="date"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label
                      >Number of days <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="days"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Remaining Leaves
                      <span class="text-danger">*</span></label
                    >
                    <input
                      :value="getRemainingDays()"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label
                      >Leave Reason <span class="text-danger">*</span></label
                    >
                    <textarea
                      v-model="reason"
                      rows="4"
                      class="form-control"
                    ></textarea>
                  </div>
                  <div class="form-group" v-if="eligibileDays > 0">
                    <div class="row">
                      <div class="col-md-1">
                        <input
                          v-model="needAllowance"
                          class="form-control"
                          type="checkbox"
                        />
                      </div>
                      <div class="col-md-10">
                        <label>Need Allowance</label>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" v-if="days > 0">
                    <button
                      class="btn btn-primary submit-btn"
                      :disabled="submitted"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Add Leave Modal -->
           <!-- /Add Department Modal -->
        <v-dialog v-model="dialogExport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Export Report</h5>
              <button type="button" class="close" @click="closeExport">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Period From <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                        v-model="fromDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                  </div>
                </div>
                <div class="form-group">
                  <label>Period To <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                        v-model="toDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                  </div>
                </div>
                <div class="form-group" v-if="!parameter2">
                  <label
                    >Employee
                    </label
                  >
                  <input type="text" v-model="parameter1" id="employeeid" name="employeeid" placeholder="Employee Code" class="form-control"/>
                </div>
                <div class="form-group" v-if="!parameter1">
                  <label
                    >Department
                    </label
                  >
                  <select
                        v-model="parameter2"
                        class="form-control"
                      >
                        <option disabled>Select Option</option>
                        <option
                          :value="item.id"
                          v-for="item in departments"
                          :key="item.id"
                          >{{
                            item.name
                          }}
                        </option>
                      </select>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onExportReport"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->

          <!-- Edit Leave Modal -->
          <v-dialog v-model="dialogEdit" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Leave</h5>
                <button type="button" @click="closeEdit">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updateLeave">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Employee <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="leave.employeeId">
                      <option>Select Staff</option>
                      <option
                        v-for="member in employees"
                        :key="member.id"
                        :value="member.id"
                      >
                        {{ member.lastName + " " + member.firstName }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Leave Type <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="leave.leaveTypeId"
                      @change="getRemainingLeaveDays"
                    >
                      <option>Select Leave Type</option>
                      <option
                        v-for="item in leaveTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group wrapper-class">
                    <label>From <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="leave.fromDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <div class="form-group">
                    <label>To <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="leave.toDate"
                        bootstrap-styling
                        class="form-control datetimepicker"
                        @closed="getNoOfDaysInterval()"
                        type="date"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      >Number of days <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="leave.days"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Remaining Leaves
                      <span class="text-danger">*</span></label
                    >
                    <input
                      :value="getRemainingDays()"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Leave Reason <span class="text-danger">*</span></label
                    >
                    <textarea
                      v-model="leave.reason"
                      rows="4"
                      class="form-control"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-1">
                        <input
                          v-model="leave.needAllowance"
                          class="form-control"
                          type="checkbox"
                        />
                      </div>
                      <div class="col-md-10">
                        <label>Need Allowance</label>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Edit Leave Modal -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button type="button" class="close" @click="closeStatus">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Leave Approve</h3>
                  <p>Are you sure want to approve for this leave?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
          <!-- Delete Leave Modal -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Leave</h3>
                  <p>Are you sure want to delete this leave?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="deleteLeave()"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Delete Leave Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogStatus: false,
      dialogDelete: false,
      dialogExport: false,
      submitted: false,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "LeaveType", value: "leaveType.name" },
        { text: "From", value: "fromDate" },
        { text: "To", value: "toDate" },
        { text: "No of Days", value: "days" },
        { text: "Need Allowance", value: "allow" },
        { text: "Reason", value: "reason" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      leaveTypeId: 0,
      days: 0,
      needAllowance: false,
      leave: {},
      employeeLeaves: [],
      employeeLeave: {},
      leaves: [],
      leaveTypes: [],
      fromDate: "",
      toDate: "",
      eligibileDays: 0,
      reason: "",
      employeeId: 0,
      employeeName: null,
      employees: [],
      employee: {},
      parameter1: '',
      parameter2: null,
      totalEmployees: 0,
      totalAbsence: 0,
      totalPendingLeave: 0,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      loading: false,
      error: "",
      message: "",
      daysInterval: "",
      status: "",
      searchParam: ""
    };
  },

  computed: {
    sortedEmployeeNames: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees ? this.employees.sort(compare) : this.employees;
    },
    filteredEmployeeLeaves: function() {
      let filteredLeaves = this.employeeLeaves
      if (this.searchParam !== "") {
        filteredLeaves = filteredLeaves.filter(l => {
          return (
            l.employee.firstName.toLowerCase().includes(this.searchParam.toLowerCase()) ||
            l.employee.lastName.toLowerCase().includes(this.searchParam.toLowerCase()) ||
            l.leaveType.name.toLowerCase().includes(this.searchParam.toLowerCase())
          );
        });
      }

      return this.employeeLeaves ? filteredLeaves : this.employeeLeaves
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeStatus();
    },
    dialogExport(val) {
      val || this.closeExport();
    }
  },

  methods: {
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.id, this.employeeId);
      this.employeeId = this.employeeName.id;
    },
    clearModel() {
      this.employeeId = "";
      this.employeeName = null
      this.reason = "";
      this.daysInterval = "";
      this.leaveDays = "";
      this.toDate = "";
      this.eligibileDays = 0;
      this.fromDate = "";
      this.leaveTypeId = 0;
      this.submitted = false;
      this.error = "";
      this.message = "";
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    openDialogExport() {
      this.dialogExport = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeExport() {
      this.dialogExport = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLeave(item) {
      this.leave = item;
      this.dialogEdit = true;
      // console.log(`item`, item)
    },

    setLeaveStatus(item) {
      this.leave = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },

    setDeleteLeave(item) {
      this.leave = item;
      this.dialogDelete = true;
    },
    getRemainingLeaveDays() {
      employeeService
        .getEmployeeLeaveEligibility(this.employeeId, this.leaveTypeId)
        .then(
          o => {
            this.eligibileDays = o;
          },
          err => (this.error = err)
        );
    },

    getSummary() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getHRLeaveSummary(unit.id).then(o => {
        this.totalEmployees = o.totalEmployees;
        this.totalAbsence = o.totalAbsence;
        this.totalPendingLeave = o.totalPendingLeave;
        console.log(this.company);
      });
    },
    deleteLeave() {
      const id = this.employeeLeave.id;
      employeeService.removeEmployeeLeave(id).then(
        id => {
          employeeService.getEmployeeLeaves(this.company.id).then(o => {
            this.employeeLeaves = o;
          });
        },
        e => {
          this.error = "Leave Type is being used in some information";
          this.dialogDelete = false;
        }
      );
    },
    setLeave(item) {
      this.employeeLeave = item;
    },
    updateLeave() {
      this.submitted = true;
      const id = this.leave.id;
      this.loading = true;
      employeeService.updateEmployeeLeave(id, this.leave).then(
        id => {
          employeeService.getEmployeeLeaves(this.company.id).then(o => {
            this.employeeLeaves = o;

            this.eligibileDays = 0;
            this.days = 0;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    changeLeaveStatus(status) {
      this.submitted = true;
      const id = this.leave.id;
      this.leave.status = status;
      this.leave.approvedBy = this.user.employee.id;
      this.leave.approvedDateByHR = new Date();
      this.loading = true;
      employeeService.updateEmployeeLeave(id, this.leave).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployeeLeaves(unit.id).then(o => {
            this.employeeLeaves = o;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getEmployeeLeaves() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeLeaves(unit.id).then(
        model => {
          this.employeeLeaves = model;
        },
        error => {
          this.error = error;
        }
      );
    },
    getEmployeeNewLeaves() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeLeaves(unit.id).then(
        model => {
          this.employeeLeaves = model.filter(
            c => c.status == 0
          );
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeApprovedLeaves() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeLeaves(unit.id).then(
        model => {
          this.employeeLeaves = model.filter(c => c.status == 1);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeRejectedLeaves() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeLeaves(unit.id).then(
        model => {
          this.employeeLeaves = model.filter(c => c.status == 2);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          //console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getLeaveTypes() {
      organizationService.getLeaveTypes().then(
        model => {
          this.leaveTypes = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    
    onExportReport() {
      if (this.fromDate == null || this.toDate == null) {
        return;
      }
      this.loading = true;
      var req = {
        start: this.fromDate,
        end: this.toDate,
        parameter1: this.parameter1,
        parameter2: this.parameter2
      };
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.exportAllLeaves(unit.id, req)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },
    onDownload(leave) {
      this.loading = true
      employeeService.exportCertificate(leave.id, leave.leaveTypeId)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },
    getNoOfDaysInterval() {
      if (this.toDate == "" || this.fromDate == "") {
        this.days = 0;
      }
      const startDate = new Date(this.fromDate);
      const endDate = new Date(this.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if(this.leaveTypeId === 2){
          count++;
          curDate.setDate(curDate.getDate() + 1);
        }else{
         if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
         curDate.setDate(curDate.getDate() + 1);
        }
      }
      this.days = count;
    },
    getNoOfDaysIntervalEdit() {
      const startDate = new Date(this.leave.fromDate);
      const endDate = new Date(this.leave.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if(this.leave.leaveTypeId === 2){
          count++;
          curDate.setDate(curDate.getDate() + 1);
        }else{
          if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
          curDate.setDate(curDate.getDate() + 1);
        }
      }
      this.leave.days = count;
    },
    getRemainingDays() {
      if (this.toDate == "" || this.fromDate == "") {
        return this.eligibileDays;
      }
      const startDate = new Date(this.fromDate);
      const endDate = new Date(this.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return this.eligibileDays - count;
    },
    getRemainingDaysEdit() {
      const startDate = new Date(this.leave.fromDate);
      const endDate = new Date(this.leave.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return this.eligibileDays - count;
    },
    // setLeaveType() {
    //   this.leaveType = this.leaveTypes.map((a) => a);
    //   //console.log(this.leaveType)
    // },
    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     return;
      // }

      if (this.getRemainingDays() < 0) {
        this.error =
          "Your remainding  leave days is not enoungh for the days you want";
        console.log("na bddb");
        return;
      }
      if (this.reason == "") {
        return (this.error = "Enter leave reason!");
      }
      console.log(`this.days`, this.days);

      this.loading = true;
      employeeService
        .addEmployeeLeave(
          this.company.id,
          this.employeeId,
          this.fromDate,
          this.toDate,
          this.days,
          this.reason,
          this.leaveTypeId,
          this.user.employee.id,
          1,
          this.needAllowance
        )
        .then(
          id => {
            this.message = "New Leave Added successfully";
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            employeeService.getEmployeeLeaves(unit.id).then(
              model => {
                this.employeeLeaves = model;
                console.log(model[0]);
                this.message = "";
                this.eligibileDays = 0;
                this.days = 0;
                this.close();
              }
              // error => { error = error }
            );
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    }
  },
  mounted() {
    this.getLeaveTypes();
    this.getSummary();
    this.getEmployees();
    this.getEmployeeLeaves();
    this.getDepartments();
    //this.setDaysInterval()
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/leaves/leaves.vue